import React from "react";
import mainImg from "../assets/mainImg/blackImg.png";
import bgImg from '../assets/mainImg/SSKmain.jpeg'
import { stats, services } from "./data";
import { Phone, Car, Sparkles, ArrowRight, Rainbow } from "lucide-react";

export const HomeHeroSection = ({
  setShowForm,
  setTab,
  activeTab,
  scrollRef,
}) => {

  return (
    <section className="relative py-10 sm:py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* HERO */}
<div
  style={{ backgroundImage: `url(${bgImg})` }}
  className="
    relative
    min-h-[70vh] sm:h-96 md:h-screen
    w-full
    flex flex-col md:flex-row
    items-center
    gap-10 md:gap-16 lg:gap-24
    px-4 sm:px-6 md:px-10
    py-12 sm:py-14
    bg-cover bg-center bg-no-repeat
    rounded-2xl sm:rounded-3xl
    shadow-[0_10px_40px_rgba(0,0,0,0.8)]
    overflow-hidden
  "
>
        </div>

{/* LEFT */}
<div className="flex-1 pt-5 order-1 text-center md:text-center z-10">
  {/* Badge - Centered */}
  <div className="inline-flex items-center justify-center px-4 py-2 rounded-full text-white mb-5 shadow-lg shadow-pink-500/40 bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500/20 animate-pulse mx-auto">
    <Sparkles className="h-4 w-4 mr-2" />
    <span className="text-xs sm:text-sm font-semibold whitespace-nowrap">
      PREMIUM TRAVEL SERVICES
    </span>
    <Rainbow className="h-4 w-4 ml-2" />
  </div>

  {/* Company Name with Contact Info integrated - Centered */}
  <div className="mb-8">
    <h1 className="text-2xl md:text-4xl font-bold text-white mb-4 tracking-tight text-center">
      SSK SIRANJEEVI TRAVELS
    </h1>
    
    <div className="flex flex-col sm:flex-row justify-center items-center gap-4 p-4 rounded-xl">
      <div className="flex items-center gap-3 px-3 py-2 bg-black/30 rounded-lg">
        <Phone className="h-5 w-5 text-pink-300" />
        <span className="text-white font-semibold text-lg">9551776782</span>
      </div>
      
      <div className="flex items-center gap-3 px-3 py-2 bg-black/30 rounded-lg">
        <Phone className="h-5 w-5 text-blue-300" />
        <span className="text-white font-semibold text-lg">9566696782</span>
      </div>
    </div>
  </div>

  {/* Buttons Side by Side - Centered */}
  <div className="flex flex-col sm:flex-row gap-4 justify-center">
    <button
      onClick={() => setShowForm(true)}
      className="group flex-1 max-w-md px-8 py-4 bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 text-white rounded-xl font-semibold flex items-center justify-center shadow-lg shadow-pink-500/40 hover:scale-105 transition-transform"
    >
      <Car className="h-5 w-5 mr-3" />
      <span>Book Your Ride</span>
      <ArrowRight className="h-5 w-5 ml-3 group-hover:translate-x-2 transition-transform" />
    </button>

    <a
      href="tel:9551776782"
      className="flex-1 max-w-md px-8 py-4 bg-white/10 text-white rounded-xl font-semibold flex items-center justify-center border border-white/20 hover:bg-white/20 hover:scale-105 transition-transform"
    >
      <Phone className="h-5 w-5 mr-3" />
      <span>Call Now</span>
    </a>
  </div>
</div>
        {/* STATS */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 my-12">
          {stats.map((stat, i) => (
            <div
              key={i}
              className="bg-white/5 backdrop-blur-xl rounded-2xl p-4 sm:p-6 border border-white/20 shadow-lg"
            >
              <div className="flex items-center mb-3">
                <div className={`p-3 rounded-lg ${stat.color} text-white mr-3`}>
                  {React.cloneElement(stat.icon, {
                    className: "h-5 w-5",
                  })}
                </div>
                <div className="text-xl sm:text-2xl font-bold text-white">
                  {stat.number}
                </div>
              </div>
              <p className="text-white/80 text-sm sm:text-base">
                {stat.label}
              </p>
            </div>
          ))}
        </div>

        {/* SERVICES */}
        <div className="mb-16">
          <h2 className="text-center text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-6">
            Our Colorful Services
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
            {services.map((service) => (
              <button
                key={service.id}
                onClick={() => {
                  setTab(service.id);
                  scrollRef.current.scrollIntoView({ behavior: "smooth" });
                }}
                className={`rounded-xl p-4 sm:p-5 text-center transition-all shadow-lg ${
                  activeTab === service.id
                    ? `${service.bgColor} text-white scale-105`
                    : "bg-white/10 text-white hover:bg-white/20"
                }`}
              >
                <div className="flex justify-center mb-3">
                  {React.cloneElement(service.icon, {
                    className: "h-6 w-6",
                  })}
                </div>
                <div className="font-bold text-sm sm:text-base">
                  {service.title}
                </div>
                <p className="text-xs sm:text-sm text-white/80 mt-1">
                  {service.subtitle}
                </p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
